<template>
  <div v-if="title || rightText" class="m-blockheader"><!-- Start title -->
    <div class="m-blockheader--row"><!-- Start title -->
      <div v-if="title" class="m-blockheader--row__title">
        <i v-if="faIconClass" :class="faIconClass" aria-hidden="true"></i> {{ title }}
      </div>
      <div v-if="rightText" class="m-blockheader--row__description">{{ rightText }}</div>
    </div><!-- End Title -->
    <hr>
  </div><!-- End Title -->
</template>

<script>

export default {
  props: ['title', 'faIconClass', 'rightText']
}
</script>



// WEBPACK FOOTER //
// BlockHeader.vue?60b986f4